import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
// ---- image imports ----
import img01 from "../../images/team/img01.jpg";
import img02 from "../../images/team/img03 (2).jpg";
import img03 from "../../images/team/img02.jpg";
import img04 from "../../images/team/aditi.jpg";
import img05 from "../../images/team/suma.jpg";
import img06 from "../../images/team/sabrinaa.jpg";
import img07 from "../../images/team/img07.jpg";
import img08 from "../../images/team/img08.jpg";
import img09 from "../../images/team/img09.jpg";
import img10 from "../../images/team/img10.jpg";

import bgLarge from "../../images/team/noice-bg02.png";
import bgSmall from "../../images/team/noice-bg.png";


// ---- team data ----
const teamMembers = [
  {
    name: "Leo Wildeman",
    role: "Business Growth Advisor",
    img: img09,
    big: true,
  },
  {
    name: "Sheznan Tayab Navid",
    role: "Data Science Enthusiast",
    img: img10,
    big: true,
  },
  {
    name: "Ferdous Apurba",
    role: "Data Analyst",
    img: img01,
    big: false,
  },
  {
    name: "Raisul Islam",
    role: "Data Analyst",
    img: img03,
    big: false,
  },
  {
    name: "Aditi Barua",
    role: "Data Analyst",
    img: img04,
    big: false,
  },
  {
    name: "Md Sakhawat Hossain",
    role: "Data Analyst",
    img: img02,
    big: false,
  },
 
  {
    name: "Sabrina Jashim",
    role: "Data Analyst",
    img: img06,
    big: false,
  },
  {
    name: "Sumaiya Salim",
    role: "Web Developer",
    img: img05,
    big: false,
  },
 
];

const TeamPage: React.FC = () => {
  useEffect(() => {
                              document.title = "Team | Brain Machine AI";
                            }, []);
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Our team" pagesub="Our team" />
            <section className="team">
              <div className="container">
                <div className="row mt-none-55">
                  {teamMembers.map((item, idx) => (
                    <div
                      key={idx}
                      className={
                        item.big
                          ? "col-xl-6 col-lg-6 col-md-8 mt-55"
                          : "col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-55"
                      }
                    >
                      <div
                        className={
                          item.big
                            ? "xb-team-item xb-team-item-big xb-border"
                            : "xb-team-item xb-border"
                        }
                      >
                        <div className="xb-item--img">
                          <img src={item.img} alt={item.name} />
                        </div>

                        <div className="xb-item--holder ul_li_between">
                          <div className="xb-item--author">
                            <h2 className="xb-item--name">{item.name}</h2>
                            <span className="xb-item--desig">{item.role}</span>
                          </div>

                          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="xb-item--social xb-border">
                            <i className="fa-brands fa-linkedin-in"></i>
                          </a>
                        </div>

                        <div className="xb-bg">
                          <img src={item.big ? bgLarge : bgSmall} alt="background" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default TeamPage;
